import _ from 'lodash'
export const HopperPlugin = function () {}

HopperPlugin.install = function (Vue, options) {
  // 1. 전역 메소드 또는 속성 추가
  // Vue.myGlobalMethod = function () {
  //   // 필요한 로직 ...
  // }

  // // 2. 전역 에셋 추가
  // Vue.directive('my-directive', {
  //   bind (el, binding, vnode, oldVnode) {
  //     // 필요한 로직 ...
  //   }
  // })

  // 3. 컴포넌트 옵션 주입
  Vue.mixin({
    // created: function () {
    //   if (this.isEditMode) {
    //     this.init()
    //   }
    // },
  })

  // // 4. 인스턴스 메소드 추가
  Vue.prototype.$search = async function (url, param) {
    const { query } = this.$route
    if (query.search && (!query.searchType || query.searchType === '')) {
      alert('검색 조건을 선택해 주세요')
    }
    try {
      const params = {
        ...this.$utils.params('page'),
        ...this.$utils.params('order'),
        ...this.$utils.params('orderType'),
        ...this.$utils.params('search'),
        ...this.$utils.params('searchType'),
        ...this.$utils.params('useFlag'),
        ...this.$utils.params('filter'),
        ...param
      }

      const res = await this.$http.get(url, { params })
      console.log(res.data)
      const { count, rows } = res.data
      return {
        count,
        rows: rows.map(row => {
          row.selected = false
          return row
        })
      }
    } catch (ex) {
      console.log(ex)
    } finally {
      this.selected = false
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }
  }

  Vue.prototype.$remove = async function (url) {
    if (!confirm('정말로 삭제하시겠습니까?')) {
      return false
    }
    try {
      await this.$http.delete(url)
    } catch (ex) {
      console.log(ex)
      alert('잘못된 비밀번호거나 시스템에 문제가 발생하였습니다. 관리자에게 문의해 주세요')
      return false
    }
    return true
  }

  Vue.prototype.$removeSelected = async function (cbUrl, rows) {
    const selectedRows = rows.filter(row => {
      return row.selected
    })
    if (selectedRows.length === 0) {
      return
    }

    if (!confirm('정말로 삭제하시겠습니까?')) {
      return false
    }

    const promises = selectedRows.map(async row => {
      return this.$http.delete(cbUrl(row))
    })
    await Promise.all(promises)
      .then(res => {
        console.log(res)
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        // this.search()
      })
    return true
  }

  Vue.prototype.$selectAll = async function (rows, selected) {
    return rows.map(row => {
      row.selected = selected
      return row
    })
  }

  Vue.prototype.$load = async function (uri) {
    const { query } = this.$route
    try {
      const res = await this.$http.get(uri, { params: query })
      this.row = {
        ...this.row,
        ...res.data
      }
      console.log('this.row', this.row)
      const copyed = _.cloneDeep(this.row)
      this.origin = {
        ...copyed
      }
      this.error = {}
      console.log(res.data)
    } catch (ex) {
      // if (ex.response.status === 403) {
      //   this.$router.push({ name: 'login' })
      // }
      console.log(ex)
      throw ex
    }
  }
  Vue.prototype.$create = async function (uri) {
    try {
      console.log('create', this.row)

      return await this.$http.post(uri, this.row)
    } catch (ex) {
      // window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      console.error(ex, ex.response)

      if (ex.response) {
        const { fieldId, errorMessage } = ex.response.data
        if (fieldId === 'system') {
          alert('문제가 발생하였습니다. 관리자에게 문의해 주세요')
          return
        }

        const error = { fieldId, errorMessage }
        throw error
      }
    }
  }
  Vue.prototype.$update = async function (uri) {
    try {
      const payload = this.$utils.diff(this.row, this.origin)
      if (Object.keys(payload).length === 0) {
        return false
      }
      console.log('update', payload)

      return await this.$http.patch(uri, payload)
    } catch (ex) {
      // window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      console.error(ex, ex.response)
      if (ex.response) {
        const { fieldId, errorMessage } = ex.response.data
        if (fieldId === 'system') {
          alert('문제가 발생하였습니다. 관리자에게 문의해 주세요')
          return false
        }
        const error = { fieldId, errorMessage }
        throw error
      }
    }
    return false
  }
}
